import { createSelector, createStructuredSelector } from 'reselect';
import _get from 'lodash/get';
import { modelNameMapping, registrationType } from '~/common/utils/consts';
import {
  addCarDomain,
  appDataDomain,
  loaderDomain,
  rootDomain,
  translationsDomain,
} from './domains';

const initialDataSelect = createSelector(
  appDataDomain,
  data => data
);

export const showLoaderSelect = createSelector(
  loaderDomain,
  ({ show }) => !!show
);

export const isCNSelect = createSelector(
  appDataDomain,
  ({ locale }) => locale === 'zh_CN'
);

export const isBusinessTypeSelect = createSelector(
  addCarDomain,
  ({ registrationInfo }) => _get(registrationInfo, 'registrationType') === registrationType.BUSINESS
);

export const commonTranslationSelect = createSelector(
  translationsDomain,
  ({ common }) => common || {}
);

export const showLoaderSelector = createSelector(
  rootDomain,
  ({ globalLoader }) => _get(globalLoader, 'show')
);

export const imageUrlSelect = createSelector(
  appDataDomain,
  ({ imageUrl }) => imageUrl
);

export const vinSelect = createSelector(
  [appDataDomain, translationsDomain],
  ({ vin }, { common }) => `${_get(common, 'vin')} ${vin}`
);

export const modelSelect = createSelector(
  appDataDomain,
  ({ model }) => modelNameMapping[model]
);

export const localeSelect = createSelector(
  appDataDomain,
  ({ locale }) => locale || 'en_US'
);

export const addCarErrorMessagesSelect = createSelector(
  translationsDomain,
  ({ addCar }) => _get(addCar, 'errorMessages') || {}
);

export const rnSelect = createSelector(
  appDataDomain,
  ({ rn }) => rn || ''
);

export const isOverChargeEnabledSelect = createSelector(
  appDataDomain,
  ({ isOverChargeEnabled }) => isOverChargeEnabled
);

export default createStructuredSelector({
  initialData: initialDataSelect,
  showLoader: showLoaderSelect,
  commonTranslations: commonTranslationSelect,
  imageUrl: imageUrlSelect,
  vin: vinSelect,
  model: modelSelect,
  locale: localeSelect,
  isCN: isCNSelect,
  isBusiness: isBusinessTypeSelect,
});
